import type { ContentLibraryProps } from "@rce-web/ui-content-library";
import dynamic from "next/dynamic";

export const ContentLibrary = dynamic<ContentLibraryProps>(
  () => import("./content-library"),
  {
    ssr: false,
  }
);
